// snackbarStore.ts
import { useState } from "react";

type SnackbarState = {
  message: string;
  open: boolean;
  type?: "success" | "error" | "info";
};

let setSnackbarState: React.Dispatch<React.SetStateAction<SnackbarState>>;

export function useSnackbarStore() {
  const [state, setState] = useState<SnackbarState>({
    message: "",
    open: false,
    type: "info",
  });
  setSnackbarState = setState;
  return state;
}

export function showSnackbar(message: string, type: SnackbarState["type"] = "info") {
  if (setSnackbarState) {
    setSnackbarState({ message, open: true, type });
  }
}

export function closeSnackbar() {
  if (setSnackbarState) {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  }
}
